import React from 'react';
import PropTypes from 'prop-types';

import env from 'Env';

import 'Components/PickAndMix/Cards/PickAndMixCriticScore.scss';

const PickAndMixCriticScore = ({ metaCriticScore, openCriticScore }) => {
  const scoreThreshold = Number(env.percentRecommendedThreshold || 0);
  const showMetacritic = metaCriticScore >= scoreThreshold;
  const showOpencritic = openCriticScore >= scoreThreshold;
  let score = null;
  let imgAlt;
  let imgSrc;

  if (showMetacritic) {
    score = metaCriticScore;
    imgSrc = 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-icon.svg';
  } else if (showOpencritic) {
    score = openCriticScore;
    imgSrc = 'https://cdn.fanatical.com/production/brand/opencritic/svg/opencritic-icon.svg';
  }

  if (!score) return false;

  return (
    <div className="PickAndMixCriticScore">
      <div className="PickAndMixCriticScore__score">
        {score}
      </div>
      <div className="PickAndMixCriticScore__icon">
        <img
          width="100px"
          src={imgSrc}
          alt={imgAlt}
        />
      </div>
    </div>
  );
};

PickAndMixCriticScore.propTypes = {
  metaCriticScore: PropTypes.number,
  openCriticScore: PropTypes.number,
};

PickAndMixCriticScore.defaultProps = {
  metaCriticScore: 0,
  openCriticScore: 0,
};

export default PickAndMixCriticScore;
